import {
	Typography,
} from '@apostrophe/ui';
import styled from 'styled-components';

import { media } from '../../../styledComponents/utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  flex-grow: 1;
  margin-bottom: 40px;
`

export const UpdatedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center; 
  flex-grow: 1;
  margin-bottom: 32px;

	${media.tablet`
	text-align: center;
	`}
`


export const StyledHeader = styled(Typography).attrs({
	variant: 'subtitle1',
	weight: 'medium',
})`
  font-style: italic;
  margin-bottom: 8px;

	${media.tablet`
	text-align: center;
	`}
`;

export const StyledBody = styled(Typography).attrs({
	variant: 'body1',
	color: 'secondary',
	weight: 'normal',
})`
	${media.tablet`
	text-align: center;
	`}
`;
